import React from "react";
import {Button, Dropdown, Menu} from "antd";
import clsx from "clsx";

import HazardMon from "../../assets/img/HazardMon.svg";

import classes from "./LandingHeader.module.scss";
import {DownOutlined} from "@ant-design/icons";
import {Link, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectUserState} from "../../store/selectors";
import {userAC} from "../../store/branches/user/actionCreators";


interface HeaderProps {
    isRegister: boolean;
    onLogin: (isRegister: boolean) => void;
    activationLink?: boolean;
    is2FAVerify?: boolean;
}


const LandingHeader: React.FC<HeaderProps> = ({isRegister, onLogin, activationLink,is2FAVerify}) => {
    const {auth_key} = useSelector(selectUserState);
    const history = useHistory();
    const dispatch = useDispatch();
    const state = useSelector(state => state)
    // @ts-ignore
    const largeLogoUrl: string = state?.authReducer?.layoutSettings?.logo
    const largeLogo = largeLogoUrl ? largeLogoUrl : HazardMon

    const handleLogin = () => {
        if (activationLink) {
            return history.push("/");
        }
        if(is2FAVerify){
            dispatch(userAC.logOut());
        }
        onLogin(true);
    };


    const menu = (
        <Menu key={"feedback"}>
            <Menu.Item>
                <Link to="/feedback">
                    Send Feedback
                </Link>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className={clsx("d-flex", classes.wrap)}>

            <div className={classes.logo}>
                <img src={largeLogo ? largeLogo : HazardMon}
                     className={clsx( largeLogo && classes.largeImg)}
                     alt="HazardMon"/>
            </div>

            <div className={classes.connect}>
                <div className={classes.connectWrap}>
                    <div className={classes.contactSelect}>
                    <Dropdown overlay={menu} placement="topRight" arrow>
                            <Button className={classes.select} type={"text"}>Contact Us <DownOutlined/></Button>
                        </Dropdown>
                    </div>
                </div>

            </div>
        </div>
    );
};
export default LandingHeader;
